// extracted by css-extract-rspack-plugin
export default {"cls1":"SwpBulkFollowTakeover-cls1_XHL","cls2":"SwpBulkFollowTakeover-cls2_kYG SwpBulkFollowTakeover-cls1_XHL"};